import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import DesktopNotifications from "../../components/notifications/DesktopNotifications";
import MobileNotifications from "../../components/notifications/MobileNotifications";
import DeleteNotificationsModal from "../../components/notifications/DeleteNotificationsModal";

function Notifications({ windowSize, notifications }) {
  const [show, setShow] = useState(false);

  return (
    <div id="notifications">
      {windowSize > 576 ? (
        <DesktopNotifications showModal={() => setShow(true)} />
      ) : (
        <MobileNotifications showModal={() => setShow(true)} />
      )}

      {!!notifications.length && (
        <DeleteNotificationsModal
          show={show}
          setShow={(status) => setShow(status)}
        />
      )}
    </div>
  );
}

Notifications.propTypes = {
  windowSize: PropTypes.number.isRequired,
  notifications: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
  notifications: state.userReducer.notifications,
});

export default connect(mapStateToProps)(Notifications);
